var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcClockTransparent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.33,
    height: 13.33,
    viewBox: "0 0 13.33 13.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_open-clock",
    "data-name": "Icon open-clock",
    d: "M6.665,0A6.665,6.665,0,1,0,13.33,6.665,6.685,6.685,0,0,0,6.665,0Zm0,1.666a5,5,0,1,1-5,5A4.992,4.992,0,0,1,6.665,1.666ZM5.832,3.333v3.7l.267.217.833.833.567.633,1.2-1.2-.633-.567L7.5,6.382V3.366H5.832Z",
    fill: "#8b9095"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcClockTransparent);
export default __webpack_public_path__ + "static/media/ic-clock-transparent.c51a7593.svg";
export { ForwardRef as ReactComponent };